import { gql } from 'apollo-boost';

export const LOGIN = gql`
mutation authenticator($email: String!, $password: String!) {
         authenticator(input: { email: $email, password:$password }) {
          access_token
      }
    }
    `;